export default {
  disableServiceTitle: "You're about to disable {{service}} in {{branch}}",
  disableServiceSubtitle:
    "Select a reason for this change. It will be logged in the brand's action logs.",
  scheduledDisableTitle: "Edit scheduled disable",
  scheduledDisableSubtitle: "Update the scheduled disable for {{branch}}.",
  reasonLabel: "Reason",
  reasonRequired: "Please select a reason",
  customDateRequired: "Please select a date and time",
  durationLabel: "Duration",
  autoResumeLabel: "{{service}} will automatically be turned back in",
  autoResumeOnDateLabel: "{{service}} will automatically be turned back on {{date}}",
  duration_1h: "1 hour",
  duration_2h: "2 hours",
  duration_1d: "1 day",
  duration_1w: "1 week",
  duration_1m: "1 month",
  duration_custom: "Custom date/time",
  duration_permanent: "No due date",
  reasonSelectPlaceholder: "Select a reason",
  reasonPosIssue: "POS issue",
  reasonStaffShortage: "Staff shortage",
  reasonRamadanHours: "Ramadan hours",
  reasonMaintenance: "Maintenance",
  reasonBrandRequest: "Brand request",
  reasonOther: "Other - Please specify",
  specifyReasonPlaceholder: "Specify reason",
  cancel: "Cancel",
  apply: "Apply",
  save: "Save",
  confirmDisable: "Confirm disable",
  enable: "Enable",
  updateScheduled: "Update scheduled action",
  pickup: "Pickup",
  delivery: "Delivery",
  driveThru: "Drive Thru",
  offlineLoyalty: "Offline Loyalty Status",
  onlineLoyalty: "Online Loyalty Status",
  scheduledDisableTooltip: "This branch is scheduled to be disabled",
  badgeUntilLabel: "Until {{date}}",
  badgePermanentLabel: "Permanent",
  badgeReasonLabel: "Reason: {{reason}}",
  badgeDurationLabel: "Duration: {{duration}}",
};
